module.exports = __webpack_public_path__ + "static/media/front-section1-bg.b8ded3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/front-section1-bg.png
// module id = 697
// module chunks = 0